import "./AttachmentPreviewComponent.scss";
import {IAttachment} from "../../models/common.model";
// import 'react-image-lightbox/style.css';
import React, {useCallback, useEffect, useRef, useState} from "react";
import {CommonService} from "../../services";
import {Subscription} from "rxjs";
import PdfViewerComponent from "../pdf-viewer/PdfViewerComponent";
import StatusCardComponent from "../status-card/statusCardComponent";
import DialogComponent from "../dialog/dialogComponent";

// const CURRENTLY_SUPPORTED_FILE_FORMATS: any = ['image', 'pdf', 'video'];
const CURRENTLY_SUPPORTED_FILE_FORMATS: any = ['pdf'];

const AttachmentPreviewComponent = () => {
    const [attachments, setAttachments] = useState<IAttachment[]>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [activeAttachment, setActiveAttachment] = useState<IAttachment>(attachments[0]);
    const [activeAttachmentType, setActiveAttachmentType] = useState<string | undefined>(undefined);
    const lightBoxSubjectRef = useRef<Subscription>();
    const closeLightBox = useCallback(() => {
        setIsOpen(false);
    }, []);

    const openLightBox = useCallback(() => {
        setIsOpen(true);
    }, []);

    useEffect(() => {
        if (attachments) {
            setActiveAttachment(attachments[0]);
            openLightBox();
        }
    }, [attachments, openLightBox]);

    useEffect(() => {
        if (activeAttachment) {
            setActiveAttachmentType(CommonService.getNormalizedFileType(activeAttachment.type));
        }
    }, [activeAttachment]);

    useEffect(() => {
        lightBoxSubjectRef.current = CommonService._communications.AttachmentPreviewSubject.subscribe((attachments: IAttachment[]) => {
            setAttachments(attachments);
        });
        return () => {
            lightBoxSubjectRef.current?.unsubscribe();
            closeLightBox();
        }
    }, [closeLightBox]);

    useEffect(() => {
        CommonService.changeNeedHelpPlacement(Boolean(isOpen && activeAttachment));
        // Cleanup function to ensure class is removed when component unmounts or conditions change
        return () => {
            CommonService.changeNeedHelpPlacement(false);
        };
    }, [activeAttachment, isOpen]);

    return (
        <>
            {(isOpen && activeAttachment) && <>
                <div className={'attachment-preview-component'}>
                    {
                        CURRENTLY_SUPPORTED_FILE_FORMATS.includes(activeAttachmentType) && <>
                            {/*{*/}
                            {/*    activeAttachmentType === "image" && <Lightbox*/}
                            {/*        mainSrc={activeAttachment?.url}*/}
                            {/*        onCloseRequest={() => setIsOpen(false)}*/}
                            {/*    />*/}
                            {/*}*/}
                            {
                                activeAttachmentType === "pdf" &&
                                <PdfViewerComponent file={activeAttachment.url} title={activeAttachment?.name}
                                                    onClose={closeLightBox}/>
                            }
                            {/*{*/}
                            {/*    activeAttachmentType === "video" &&*/}
                            {/*    <VideoPlayerComponent url={activeAttachment.url} onClose={closeLightBox}/>*/}
                            {/*}*/}
                        </>
                    }
                    {
                        !CURRENTLY_SUPPORTED_FILE_FORMATS.includes(activeAttachmentType) && <>  <DialogComponent
                            open={true}
                            maxWidth={'md'}
                            title={'Unsupported File'}
                            onClose={closeLightBox}
                            isShowCancel={true}
                        >
                            <StatusCardComponent title={`File format not supported to preview right now, Coming soon`}>
                            </StatusCardComponent>
                        </DialogComponent>
                        </>
                    }
                </div>
            </>}
        </>
    );

};

export default AttachmentPreviewComponent;
